/*=========================================================================================
  File Name: module-servicetvantax.js
  Description: servicetvanTax Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-servicetvan-state';
import mutations from './module-servicetvan-mutations';
import actions from './module-servicetvan-actions';
import getters from './module-servicetvan-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
